import { Layout } from 'antd';
import React, { useEffect } from 'react';
import SideNavBar from '../../Components/SideBar/Sidebar';
import { Content, Header } from 'antd/es/layout/layout';
import Navbar from '../../Components/Support/Header';
import { embedDashboard } from "@superset-ui/embedded-sdk";
import axios from "axios";
import '../Analytics/Graph.css'

const Graph = () => {

    const SUPERSET_URL = "https://payrolldevlinux.spectraforce.com/superset"
    const SUPERSET_USERNAME = "alpha_user"
    const SUPERSET_PASSWORD = "alpha_user"
    const SUPERSET_FIRSTNAME = "Alpha"
    const SUPERSET_LASTNAME = "User"
    const SUPERSET_DASHBOARD_ID = "33be061b-e35d-4f12-89e3-a238e288b588"

    const requestData = {
        user: {
            username: SUPERSET_USERNAME,
            first_name: SUPERSET_FIRSTNAME,
            last_name: SUPERSET_LASTNAME,
        },
        rls: [],
        resources: [
            {
                type: 'dashboard',
                id: SUPERSET_DASHBOARD_ID,
            },
        ],
    };

    useEffect(() => {
        fetchData();
    }, []); // Add guestToken to the dependency array if needed

    const fetchData = async () => {
        try {

            // Fetch JWT token
            const tokenResponse = await axios.post(
                SUPERSET_URL + '/api/v1/security/login',
                {
                    username: SUPERSET_USERNAME,
                    password: SUPERSET_PASSWORD,
                    provider: 'db',
                    refresh: true,
                }, {
                withCredentials: true,
            });

            const jwtToken = tokenResponse.data.access_token; // Superset JWT Token

            // Fetch guest token
            const gtokenResponse = await axios({
                method: 'POST',
                url: SUPERSET_URL + '/api/v1/security/guest_token/',
                data: requestData,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${jwtToken}`,
                },
            });

            const guestToken = gtokenResponse.data.token; // Superset Guest Token

            // Embed Superset dashboard
            embedDashboard({
                id: SUPERSET_DASHBOARD_ID,
                supersetDomain: SUPERSET_URL,
                mountPoint: document.getElementById('my-superset-container'),
                fetchGuestToken: () => guestToken,
                dashboardUiConfig: {
                    hideTitle: true,
                    filters: {
                        expanded: true,
                    },
                },
            });
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    return (
        <>
            <Layout style={{ backgroundColor: "white", height: "100vh", display: "flex", overflow: "hidden" }} >
                <SideNavBar />
                <Layout className="whole-div">
                    <Header className="timecards-header">
                        <Navbar />
                    </Header>
                    <Content>
                        <div id="my-superset-container" className='superset-container'></div>
                    </Content>
                </Layout>
            </Layout>
        </>
    );
};

export default Graph;
